import React from "react";

import {
    Card,
    Empty,
    List,
    Typography
} from "antd";

import {
    MessageOutlined
} from "@ant-design/icons";

const {
    Text,
    Title
} = Typography;


const NegotiationList = ({
                             notifications = []
                         }) => {

    if (!notifications.length) {
        return (
            <Empty
                description="Aucune négociation en cours"
            />
        );
    }

    return (
        <List
            dataSource={notifications}
            rowKey={notification => notification.id}
            renderItem={notification => (

                <List.Item>

                    <Card
                        style={{
                            width: "100%",
                            borderRadius: 12
                        }}
                    >

                        <Title
                            level={5}
                            style={{
                                marginBottom: 8
                            }}
                        >
                            <MessageOutlined />
                            {" "}
                            {notification.title ||
                                "Négociation"}
                        </Title>

                        <Text>
                            {notification.message}
                        </Text>

                        {notification.createdAt && (

                            <div
                                style={{
                                    marginTop: 8
                                }}
                            >

                                <Text
                                    type="secondary"
                                >
                                    {new Date(
                                        notification.createdAt
                                    ).toLocaleString(
                                        "fr-FR"
                                    )}
                                </Text>

                            </div>

                        )}

                    </Card>

                </List.Item>

            )}
        />
    );
};

export default NegotiationList;